export { default } from '../code-block';
export type { CodeBlockProps } from '../types';
